import { useEffect, useState } from "react";
import useFetchWrapper, { HttpResponse } from "../../../Helpers/useFetchWrapper";
import { Props, Renewal, TableData, TabStatus, User } from "./RenewalTab.model";

export const pageSize = 10;

export const useRenewalTab = ({ filters }: Props) => {
	const [mentors, setMentors] = useState<TableData[]>();
	const [pagination, setPagination] = useState({ page: 1, size: pageSize, total: 0 });
	const [tabStatus, setTabStatus] = useState(TabStatus.Loading);
	const [showPopup, setShowPopup] = useState(false);
	const [selectedMentor, setSelectedMentor] = useState<TableData>();

	const { get } = useFetchWrapper();

	const getMentors = async () => {
		setTabStatus(TabStatus.Loading);
		const response: HttpResponse<{ count: number, mentors: Renewal[] }> = await get(`/user/downgrade/all?page=${pagination.page}&size=${pagination.size}&${filters}`);
		if (response.parsedBody) {
			const { mentors, count } = response.parsedBody;
			setMentors(mentors.map(item => ({
				imageId: item.mentor.imageId,
				isDeleted: item.mentor.isDeleted,
				name: `${item.mentor.firstName} ${item.mentor.lastName}`,
				timeLeft: item.timeLeft,
				userId: item.mentor.userId
			})));
			setTabStatus(TabStatus.Loaded);
			setPagination({ ...pagination, total: count });
		}
		else {
			setTabStatus(TabStatus.Error);
		}
	}

	useEffect(() => {
		getMentors();
	}, [pagination.page]);

	useEffect(() => {
		if (pagination.page > 1) {
			setPagination({ ...pagination, page: 1 });
		}
		else getMentors();
	}, [filters]);

	const togglePopup = () => {
		setShowPopup(value => !value);
	}

	const onChangePagination = (page: number) => {
		setPagination({ ...pagination, page });
	}

	return {
		getMentors,
		onChangePagination,
		setSelectedMentor,
		state: {
			mentors,
			pagination,
			selectedMentor,
			showPopup,
			tabStatus,
		},
		togglePopup
	}
}